import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { take } from 'rxjs';

import { Session } from '../services/Session';
import { UrlService } from '../services/UrlService';
import { LoginService } from '../services/Login.service';
import { SwitchBoard } from '../services/SwitchBoard';
import { TaxPlanningService } from '../tpiq-services/tax-planning.service';

@Component({
  selector: 'app-handoff',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div style="display:flex;align-items:center;justify-content:center;height:100vh;font-family:sans-serif;color:#666;">
      <span>Loading&hellip;</span>
    </div>
  `
})
export class HandoffComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private loginService: LoginService,
    private switchBoard: SwitchBoard,
    private taxPlanningService: TaxPlanningService
  ) {}

  ngOnInit() {
    this.route.queryParams.pipe(take(1)).subscribe(params => {
      const token = params['token'];
      const firm = params['firm'];

      if (!token || !firm) {
        this.router.navigate(['/login']);
        return;
      }

      const url = `${UrlService.getBaseUrl('JAVA')}/TaxPlanningServices/handoff?token=${encodeURIComponent(token)}&firm=${encodeURIComponent(firm)}`;

      this.http.get<any>(url).subscribe({
        next: (res) => {
          // Mirror what login.component.ts addSessionData() does
          Session.put('userId', res.userId);
          Session.setToken(res.token);
          Session.setRefreshToken(res.refreshToken);
          Session.setOrg(res.org);

          // Fetch full user profile and establish session
          this.loginService.getUserCompanyInfo(res.userId, res.org).subscribe({
            next: (user) => {
              Session.put('user', user);
              Session.setCurrentCompanyCurrency('USD');
              this.switchBoard.onLogin.next(user);

              // Set optimistic access info immediately so dashboard renders without waiting
              // for the subscription API (which may call Stripe/HubSpot and be slow).
              // The real subscription status is fetched async and updates the session.
              Session.setUserAccessInfo({ dashboardAccess: true, clientPortalAccess: true, subscriptionStatus: '' });
              this.router.navigate(['/tpiq/dashboard']);

              // Fetch real subscription status in the background to populate accurate access flags.
              this.taxPlanningService.getSubscriptionStatus(user.org, user.id).subscribe({
                next: (subscription) => {
                  const accessInfo: any = {
                    clientPortalAccess: false,
                    dashboardAccess: false,
                    subscriptionStatus: subscription.subscriptionStatus
                  };
                  if (subscription.accessList?.length > 0) {
                    accessInfo.dashboardAccess = subscription.accessList.indexOf('Dashboard') !== -1;
                    accessInfo.clientPortalAccess = subscription.accessList.indexOf('Client Portal') !== -1;
                  }
                  Session.setUserAccessInfo(accessInfo);
                }
              });
            },
            error: () => this.router.navigate(['/login'])
          });
        },
        error: () => this.router.navigate(['/login'])
      });
    });
  }
}
